import type { Server } from '../../types'

/**
 * True if `channelId` is present anywhere in the loaded server trees —
 * either a server's flat `channels` list or any of its categories' channels.
 * Used after a live `server:channels:updated` re-fetch to detect that the
 * currently-open channel was deleted / hidden, so the client can move the
 * user off a now-dead view.
 */
export function channelExistsInServers(servers: Server[], channelId: string): boolean {
  for (const s of servers) {
    if ((s.channels ?? []).some((c) => c.id === channelId)) return true
    for (const cat of s.categories ?? []) {
      if ((cat.channels ?? []).some((c) => c.id === channelId)) return true
    }
  }
  return false
}
